import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../../core/services/core.title.service';

import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { BreadcrumbService } from '../../../widgets/breadcrumbs/breadcrumbs.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';

import * as _ from 'lodash';
import { StateService } from '@uirouter/angular';
import { marker } from '../../../core/services/ngx-translate-extract-marker';

@Component({
    selector: 'wiki-referrers',
    template: require('./wiki.referrers.component.html')
})
export class WikiReferrersComponent implements OnInit {

    @Input() project: any = null;
    @Input() wikiPage: any = null;

    protected referrerItems: any = null;
    private pageName: string = '';

    constructor(
        private $window: Window,
        private wikiService: WikiService,
        private breadcrumbService: BreadcrumbService,
        private gfTranslateService: GfTranslateService,
        private stateService: StateService, 
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.pageName = _.get(this.wikiPage, 'pagename', 'FrontPage');
        this.titleService.setTitle(this.project.name, 'Wiki', this.pageName + ' - Referrers');

        this.breadcrumbService.setCrumbs([
            this.breadcrumbService.projectCrumb(this.project),
            this.breadcrumbService.translatedCrumb(marker('Wiki'), 'home.project.summary.wiki', { pagename: 'FrontPage' }),
            this.breadcrumbService.stateCrumb(this.pageName, 'home.project.summary.wiki.page', { pagename: this.pageName }),
            this.breadcrumbService.translatedCrumb(marker('Referrers'), '.', {})
        ]);

        this.loadReferrers();
    };

    private loadReferrers(): void {
        const wikiPageId = this.wikiPage?.id;

        if (wikiPageId) {
            this.fetchReferrers(wikiPageId);
            return;
        }

        // wikiPage.id may be missing when the resolve returned a fallback object.
        // Look up the page by pagename to get the real id.
        const unixName = this.stateService.params.unixName;
        const pagename = this.pageName;
        this.wikiService.info(encodeURIComponent(pagename), { project: unixName })
            .then((data: any) => {
                if (data && data.id) {
                    this.fetchReferrers(data.id);
                } else {
                    this.referrerItems = [];
                }
            }, () => {
                this.referrerItems = [];
            });
    }

    private fetchReferrers(wikiPageId: number): void {
        this.wikiService.referrers(wikiPageId)
        .then((response) => {
            this.referrerItems = _.get(response, 'items', []);
        }, () => {
            this.referrerItems = [];
        });
    }
}